import {Injectable} from '@angular/core';
import {AccountsHttpService} from "./https/accounts-http.service";
import {map, Observable} from "rxjs";
import {IResultAccounts, ResultAccounts} from 'src/app/models/accounts/accountsetting.model';

@Injectable({
  providedIn: 'root'
})
export class AccountsService {

  constructor(private http: AccountsHttpService) {
  }

  filter(wheres: {
           [key: string]: string
         }, search: string, limit: number = 100, offset: number = 0, sortField: string = '',
         sortOrder: 'asc' | 'desc' = 'asc', enableordisable: any, accountid: any): Observable<ResultAccounts> {
    return this.http
      .filter(wheres, search, limit, offset, sortField, sortOrder, enableordisable,
        accountid)
      .pipe(
        map((reportresults: IResultAccounts) => ResultAccounts.fromObject(reportresults))
      );
  }

}
